// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__2-d6I","item":"Navbar_item__2R63E","item_active":"Navbar_item_active__2Uzb6"};